import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'startEndTime',
  standalone: true // <-- Add this line
})
export class StartEndTimePipe implements PipeTransform {
  transform(value: string, format?: string): string {
    if (!value) return '';

    // Expecting value in "HH:mm:ss" format
    const [hours, minutes] = value.split(':');
    if (format === 'hm') {
      return `${hours}:${minutes}`;
    }
    return `${hours}:00:00`;
  }
}